import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'scfe-user-circle',
  templateUrl: './scfe-user-circle.component.html',
  styleUrls: ['./scfe-user-circle.component.scss']
})
export class ScfeUserCircleComponent implements OnInit {

  @Input()
  user: any;

  @Input()
  size : string = "sm";

  constructor() { }

  ngOnInit() {
  }

  getInitials() {
    if (!this.user) return "na";
    return this.user.FirstName[0] + this.user.LastName[0];
  }

  getColor() {

    var colors = {

      red : {
        textColor : "light",
        bgColor : "#f8a29e"
      },

      pink : {
        textColor : "light",
        bgColor : "#f292b1"
      },

      purple : {
        textColor : "light",
        bgColor : "#CB99D4"
      },

      deeppurple : {
        textColor : "light",
        bgColor : "##B2A0D7"
      },

      indigo : {
        textColor : "light",
        bgColor : "##9FAAD6"
      },

      blue : {
        textColor : "light",
        bgColor : "##97CCF5"
      },

      lightblue : {
        textColor : "light",
        bgColor : "#03A9F3"
      },

      cyan : {
        textColor : "light",
        bgColor : "##92DDE7"
      },

      teal : {
        textColor : "light",
        bgColor : "#A7D4A9"
      },

      green : {
        textColor : "light",
        bgColor : "#A8D5AB"
      },

      lightgreen : {
        textColor : "light",
        bgColor : "#C6DFAA"
      },

      lime : {
        textColor : "dark",
        bgColor : "#E5EBA8"
      },

      yellow : {
        textColor : "light",
        bgColor : "#FEF3AA"
      },

      amber : {
        textColor : "light",
        bgColor : "#FCDE9B"
      },

      orange : {
        textColor : "light",
        bgColor : "#FBC996"
      },

      deeporange : {
        textColor : "light",
        bgColor : "#FBAB99"
      },

      brown : {
        textColor : "light",
        bgColor : "#BBAAA4"
      },

      grey : {
        textColor : "light",
        bgColor : "#CECECE"
      },

      bluegrey : {
        textColor : "light",
        bgColor : "#B0BEC4"
      },

    }

    var charIndex = this.user.FirstName.charCodeAt(0) + this.user.LastName.charCodeAt(0);

    var keys = Object.keys(colors).reverse();
    var colorIndex = charIndex % keys.length;

    var key = keys[colorIndex];
    var value = colors[key];

    return value;
  }


}
